// Currency helper utilities

export type CurrencyCode = 'NGN' | 'USD';

export const getCurrencySymbol = (code: CurrencyCode): string => {
  return code === 'NGN' ? '₦' : '$';
};

// Belivah bills and pays out exclusively in USD (PayPal); NGN is kept only for type compatibility.
export const getPreferredCurrency = async (): Promise<CurrencyCode> => 'USD';

export const guessPreferredCurrency = (): CurrencyCode => 'USD';
// Simple display conversion helpers (approximate; replace with live FX on backend in production)
const NGN_RATE = 1500; // 1 USD ~ 1500 NGN (display only)

export const usdToCurrency = (amountUsd: number, code: CurrencyCode): number => {
  if (code === 'NGN') return Math.round(amountUsd * NGN_RATE);
  return amountUsd;
};

export const currencyToUsd = (amount: number, code: CurrencyCode): number => {
  if (code === 'NGN') return amount / NGN_RATE;
  return amount;
};

export const formatCurrency = (amountUsd: number, code: CurrencyCode): string => {
  const sym = getCurrencySymbol(code);
  const val = usdToCurrency(amountUsd, code);
  const formatted = code === 'NGN' ? Math.round(val).toString() : val.toFixed(2);
  return `${sym}${formatted}`;
};
